import { render, staticRenderFns } from "./app-download.vue?vue&type=template&id=13fc8f55&scoped=true&"
import script from "./app-download.vue?vue&type=script&lang=js&"
export * from "./app-download.vue?vue&type=script&lang=js&"
import style0 from "./app-download.vue?vue&type=style&index=0&id=13fc8f55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc8f55",
  null
  
)

export default component.exports